import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import {
  DetailDownloadControls,
  DetailRowsSection,
  DetailSearch,
  renderBackIcon,
} from "../../../shared/ui/detail-page/detail-page";
import * as DetailStyled from "../../../shared/ui/detail-page/detail-page.styled";
import { SectionSidebarNav } from "../../../shared/ui/section-sidebar-nav/section-sidebar-nav";
import { getResultById } from "../model/results";

import * as Styled from "./results.styled";

export const ResultsDetail = () => {
  const navigate = useNavigate();
  const { resultID } = useParams();
  const result = getResultById(resultID);
  const [searchInput, setSearchInput] = React.useState("");

  const navigationSections = React.useMemo(
    () => [
      { id: "order-detail", label: "Order Detail" },
      { id: "result-detail", label: "Result Detail" },
      ...(result.resultNotes
        ? [{ id: "result-notes", label: "Result Notes" }]
        : []),
    ],
    [result.resultNotes],
  );

  const sections = React.useMemo(
    () => [
      {
        id: "order-detail",
        title: "Order Detail",
        rows: result.orderDetails,
      },
      {
        id: "result-detail",
        title: "Result Detail",
        rows: result.resultDetails,
      },
    ],
    [result.orderDetails, result.resultDetails],
  );

  return (
    <Styled.Container>
      <DetailStyled.BackBtn type="button" onClick={() => navigate(-1)}>
        {renderBackIcon()}
        Back
      </DetailStyled.BackBtn>
      <DetailStyled.PageHeader>
        <Styled.Title>Result Details</Styled.Title>
        <DetailStyled.HeaderActions>
          <DetailDownloadControls fileName="result-details" />
          <DetailSearch value={searchInput} onChange={setSearchInput} />
        </DetailStyled.HeaderActions>
      </DetailStyled.PageHeader>
      <DetailStyled.DetailLayout>
        <SectionSidebarNav
          ariaLabel="Result detail sections"
          sections={navigationSections}
        />
        <DetailStyled.EntityContainer>
          {sections.map((section) => (
            <DetailRowsSection
              id={section.id}
              key={section.id}
              title={section.title}
            >
              <DetailStyled.DetailRows>
                {section.rows.map((row) => (
                  <DetailStyled.DetailRow key={row.label}>
                    <DetailStyled.Description>
                      {row.label}
                    </DetailStyled.Description>
                    <DetailStyled.Value>{row.value}</DetailStyled.Value>
                  </DetailStyled.DetailRow>
                ))}
              </DetailStyled.DetailRows>
            </DetailRowsSection>
          ))}
          {result.resultNotes ? (
            <DetailRowsSection id="result-notes" title="Result Notes">
              <DetailStyled.Notes>{result.resultNotes}</DetailStyled.Notes>
            </DetailRowsSection>
          ) : null}
        </DetailStyled.EntityContainer>
      </DetailStyled.DetailLayout>
    </Styled.Container>
  );
};
